import useRestClient from './useRestClient'
import useUtils from './useUtils'
import useCareConcepts from './useCareConcepts'

export default function useSearch(model) {
  const search = async () => {
    const {
      context,
      hasSearched,
      loading,
      searchResults,
      onlineClinics,
      currentPage,
      recommendedBadgeType,
      betterChoiceContext,
      costEstimatesFailed,
      isLocalAreaTravelNetwork,
      currentPlanName,
      currentPlanTierLabel,
      currentPlanIsTiered,
      benefitCategories,
      rawConcepts
    } = model

    const { post } = useRestClient()
    const { transFormCareConceptsForFilters } = useCareConcepts()

    if (context.value.type && context.value.latLong) {
      const url = context.value.networkId ? `/fcp/csearch/api/search?networkId=${context.value.networkId}` : '/fcp/csearch/api/search'

      try {
        loading.value = true
        const payload = { context: model.context.value }
        const results = await post(url, payload)

        //console.log("Search response is", results)

        //Set the model with the status on costEstimates from the server.
        costEstimatesFailed.value = results.costEstimatesFailed

        if (results.status == 'OK') {
          searchResults.value = results.value
          onlineClinics.value = results.onlineClinics
          recommendedBadgeType.value = results.recommendedBadgeType
          betterChoiceContext.value = results.betterChoiceContext
          isLocalAreaTravelNetwork.value = results.isLocalAreaTravelNetwork
          currentPlanName.value = results.currentPlanName
          currentPlanTierLabel.value = results.currentPlanTierLabel
          currentPlanIsTiered.value = results.currentPlanIsTiered
          benefitCategories.value = results.benefitCategories
          rawConcepts.value = results.rawConcepts ? transFormCareConceptsForFilters(results.rawConcepts) : []
          //context.value.betterChoiceContext = betterChoiceContext

        } else {
          //TODO:  What should we do if we get an error on the server?
          searchResults.value = []
          onlineClinics.value = []
        }

        //After search, make sure we go back to page 1.
        currentPage.value = 1

        //On the initial search give the UI a few extra milliseconds to render before displaying.
        if (!hasSearched.value) {
          setTimeout(function () {
            hasSearched.value = true
            loading.value = false
          }, 500)
        } else {
          hasSearched.value = true
          loading.value = false
        }

        //hasSearched.value = true
      } catch (error) {
        console.log(error)
        searchResults.value = ''
      }
    }
  }

  /**
   * Merge props from mergeFrom to mergeTo.
   * If the fields array is present only merge the fields in the fields array.
   */
  const mergeContexts = (mergeFrom, mergeTo, fields) => {
    if (fields) {
      fields.forEach((field) => {
        mergeTo[field] = mergeFrom[field]
      })
    } else {
      for (const prop in mergeFrom) {
        mergeTo[prop] = mergeFrom[prop]
      }
    }
  }

  const criteriaSearch = () => {
    const { context, criteriaContext, filterContext, sortContext } = model
    const { clone } = useUtils()

    //1) Create a new clean context
    const newContext = clone(model.cleanContext.value)
    //2) Merge criteriaContext into the new context.
    // Make sure to clear out the care concepts before merging criteriaContext into the new context 
    // so that the previously selected specialties or services are not applied to the new search
    criteriaContext.value.cc = []
    mergeContexts(criteriaContext.value, newContext)
    //console.log('criteriaSearch newContext', newContext)
    //3) Replace main context with new one.
    mergeContexts(newContext, context.value)
    //4) Replace criteriaContext, filterContext, and sortContext with the new context
    criteriaContext.value = clone(newContext)
    filterContext.value = clone(newContext)
    sortContext.value = clone(newContext)

    //5) Execute search
    search().then(() => {
      console.log('CriteriaSearch complete.')
    })

    //6) Generate an event to let the rest of the application know that a criteriaSearch as occured.  This will allow filters to re-populate themselves etc.
    const event = new CustomEvent('criteriaSearch')
    window.dispatchEvent(event)
  }

  const filter = async () => {
    const { context, filterContext, sortContext } = model
    mergeContexts(filterContext.value, context.value)
    mergeContexts(filterContext.value, sortContext.value)
    await search()
  }

  const sort = async () => {
    const { context, sortContext, filterContext } = model
    //1) Merge sortValue up to main context
    mergeContexts(sortContext.value, context.value, ['sort'])
    //2) Merge sortValue up to filterContext
    mergeContexts(sortContext.value, filterContext.value, ['sort'])
    await search()
  }

  const fns = { search, criteriaSearch, filter, sort, mergeContexts }

  return fns
}